<template>
    <header class="border-b border-gray lg:border-none flex flex-col gap-1 px-6 py-4 md:p-10 bg-white font-sans relative">
        <h1 class="min-h-[2rem] text-2xl font-bold">
            {{ productName }}
        </h1>

        <h2 class="h-7 text-xl opacity-40">
            {{price}}
        </h2>

        <p class="self-baseline font-normal absolute right-10 top-11 opacity-25">
            {{productSku}}
        </p>
    </header>
</template>

<script>
    import allStores from '../stores/all';

    // Formats the price according to current locale settings.
    function formatPrice(v, relative, locale, currency) {
        if (v == null || v === '' || v === 0) {
            return '';
        }

        const resolveCurrency = currency ?? 'USD';

        const wholeFormatter = Intl.NumberFormat(locale ?? 'en-US', {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            notation: 'standard',
            currency: resolveCurrency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        const fractionFormatter = Intl.NumberFormat(locale ?? 'en-US', {
            style: 'currency',
            currencyDisplay: 'narrowSymbol',
            notation: 'standard',
            currency: resolveCurrency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

        const formatted = v % 1 === 0 ? wholeFormatter.format(v) : fractionFormatter.format(v);

        if (relative) {
            if (formatted.startsWith('-')) {
                return formatted;
            }

            return `+${formatted}`;
        }

        return formatted;
    }

    export default {
        mixins: [allStores],

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            state() {
                return this.viewController?.state;
            },

            productName() {
                return this.customizerStore.productName;
            },

            productPrice() {
                return this.customizerStore.productPrice;
            },

            productDepartment() {
                return this.customizerStore.productDepartment;
            },

            isFemale() {
                return this.productDepartment === 'F';
            },

            departmentTranslation() {
                let text = '';

                if (this.productDepartment) {
                    text = this.isFemale ? this.$t('WOMENS') : this.$t('MENS');
                }

                return text;
            },

            locale() {
                return this.customizerStore.options?.locale;
            },

            baseUrl() {
                return this.customizerStore.buildBaseUrl();
            },

            departmentLink() {
                const department = this.isFemale ? 'women/' : 'men/';

                return `${this.baseUrl}/design-your-own/${department}`;
            },

            logoLink() {
                return `${this.baseUrl}/design-your-own/`;
            },

            productSku() {
                return this.customizerStore.productSku;
            },

            price() {
                let price = 0;

                if (this.customizerStore.cartItems != null) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const item of Object.values(this.customizerStore.cartItems)) {
                        price += item.price * item.need;
                    }
                }

                return formatPrice(price, false, 'en-US', 'USD');
            },
        },
    };
</script>
